(ns frontend.ux-overhaul.listing.company-counterparty-diligence.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.ux-overhaul.listing.company-counterparty-diligence.event :as company-counterparty-diligence-event]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "company-counterparty-diligence-listing")

(defn- open-company-counterparty-diligence!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/company-counterparty-diligence})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/company-counterparty-diligence
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :company-counterparty-diligence
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-company-counterparty-diligence
                                 :label    (loc/tr :add)
                                 :visible? true
                                 :enabled? true
                                 :event    [::company-counterparty-diligence-event/create-company-counterparty-diligence]}
                                {:id                  :bulk-edit-company-counterparty-diligences
                                 :label               (loc/tr :bulk-edit)
                                 ;; Legacy counterparty-diligence grids gate bulk-edit
                                 ;; behind :feature/bulk-edit - carried over for parity.
                                 :visible?            (session/has-feature-access? :feature/bulk-edit)
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::company-counterparty-diligence-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-company-counterparty-diligences
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::company-counterparty-diligence-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-company-counterparty-diligences
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::company-counterparty-diligence-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-company-counterparty-diligences-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::company-counterparty-diligence-event/export-grid-with-persons {:listing-id listing-id}]}]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :counterparty-diligence/company-diligence)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.company-counterparty-diligence/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::company-counterparty-diligence-event/create-company-counterparty-diligence])
         :on-row-clicked           open-company-counterparty-diligence!
         :on-card-clicked          open-company-counterparty-diligence!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/company-counterparty-diligence}]])}))
